export var spinnerContainer = 'flex justify-center items-center px-1';
export var spinnerBase = 'animate-spinner rounded-full border-2 border-t-2';
export var getSpinnerClass = function (sizeType, spinnerColor, backgroundColor) {
    switch (sizeType) {
        case 'big':
            return ('h-8 w-8 ' +
                spinnerBase +
                (' border-t-' + spinnerColor.toString()) +
                (' border-' + backgroundColor.toString()));
        case 'medium':
            return ('h-6 w-6 ' +
                spinnerBase +
                (' border-t-' + spinnerColor.toString()) +
                (' border-' + backgroundColor.toString()));
        case 'small':
            return ('h-4 w-4 ' +
                spinnerBase +
                (' border-t-' + spinnerColor.toString()) +
                (' border-' + backgroundColor.toString()));
        default:
            return ('h-3 w-3 ' +
                spinnerBase +
                (' border-t-' + spinnerColor.toString()) +
                (' border-' + backgroundColor.toString()));
    }
};
//# sourceMappingURL=loading-spinner.styles.js.map